"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runBackupJob = runBackupJob;
const organizations_1 = require("../../organizations");
const patients_1 = require("../../patients");
const events_1 = require("../../events");
const intl_1 = require("../../intl");
const api_1 = require("../../utils/api");
const basic_health_1 = require("../basic-health");
const htx_1 = require("../htx");
const ktx_1 = require("../ktx");
const ltx_1 = require("../ltx");
const queries_1 = require("./queries");
const markdown_1 = require("./markdown");
const configs = {
    basic_health: {
        queries: basic_health_1.queries,
        createHeaderValues: basic_health_1.createHeaderValues,
        createSectionList: basic_health_1.createSectionList
    },
    htx: {
        queries: htx_1.queries,
        createHeaderValues: htx_1.createHeaderValues,
        createSectionList: htx_1.createSectionList
    },
    htx_nm: {
        queries: htx_1.queries,
        createHeaderValues: htx_1.createHeaderValues,
        createSectionList: htx_1.createSectionList
    },
    ktx: {
        queries: ktx_1.queries,
        createHeaderValues: ktx_1.createHeaderValues,
        createSectionList: ktx_1.createSectionList
    },
    kd: {
        queries: ktx_1.queries,
        createHeaderValues: ktx_1.createHeaderValues,
        createSectionList: ktx_1.createSectionList
    },
    ltx: {
        queries: ltx_1.queries,
        createHeaderValues: ltx_1.createHeaderValues,
        createSectionList: ltx_1.createSectionList
    }
};
async function runBackupJob({ blockSize, blockIndex }) {
    const intl = (0, intl_1.createIntlContext)(intl_1.translations, "hu");
    const now = new Date();
    console.log("fetching jobs");
    const jobs = [];
    for (const { code: org, modules } of await (0, organizations_1.fetchOrganizationsRequest)()) {
        for (const mod of modules) {
            for (const { id } of await (0, patients_1.fetchPatientsRequest)({
                org,
                mod,
                internal: true
            })) {
                jobs.push({ org, mod, patientId: id });
            }
        }
    }
    for (let i = blockIndex * blockSize; i < Math.min((blockIndex + 1) * blockSize, jobs.length); i++) {
        console.log(`running job ${i + 1}`);
        try {
            await backupPatientData({ intl, now, ...jobs[i] });
        }
        catch (error) {
            console.error(error);
        }
    }
}
async function backupPatientData({ intl, now, org, mod, patientId }) {
    const config = configs[mod];
    if (!config) {
        throw new Error(`Invalid mod: ${mod}`);
    }
    const { queries, createHeaderValues, createSectionList } = config;
    const events = await (0, events_1.fetchEventMapRequest)({
        org,
        mod,
        patientId,
        queries: Object.values({ ...queries_1.queries, ...queries }),
        internal: true
    });
    const ssnEvent = (0, events_1.findLastEventByQuery)(events, queries_1.queries.socialSecurityNumber);
    if (!ssnEvent) {
        throw new Error("ssn not found");
    }
    const pathPrefix = getPathPrefix(now, org, mod, ssnEvent.value);
    const header = createHeaderValues(intl, { events });
    const body = createSectionList(intl, { events });
    const content = (0, markdown_1.renderPatientDataReport)(intl, { body, header });
    const savedHtmlName = await (0, api_1.uploadFileInternal)(`${pathPrefix}.html`, Buffer.from(content, "utf8"));
    return savedHtmlName;
}
function getPathPrefix(now, org, mod, ssn) {
    return `${ssn}-${org}-${mod}-${now.toISOString().slice(0, 10)}`
        .replace(/[^a-zA-Z0-9-]/g, "-")
        .replace(/-+/g, "-");
}
